<div class="custom-mat-dialog-form">
  <div>
    <h3>{{this.data?.isEditMode ? 'Update' : 'Create new'}} Factor</h3>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Code</mat-label>
              <input matInput formControlName="code" required maxlength="50" (input)="capitalizeFirst($event, 'code')">
            </mat-form-field>

            @if (form.get('code')?.invalid && (form.get('code')?.dirty || form.get('code')?.touched)) {
              <p>
                @if (form.get('code')?.hasError('required')) {
                  <mat-error>Code is required</mat-error>
                }
                @if (form.get('code')?.hasError('maxlength')) {
                  <mat-error>Code cannot exceed 50 characters</mat-error>
                }
              </p>
            }
          </div>
        </div>
      </div>

      <!-- Description Section -->
      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput required formControlName="description" rows="4" maxlength="2000" (input)="capitalizeFirst($event, 'description')"></textarea>
            </mat-form-field>

            @if (form.get('description')?.invalid && (form.get('description')?.dirty || form.get('description')?.touched)) {
              <p>
                @if (form.get('description')?.hasError('maxlength')) {
                  <mat-error>Description cannot exceed 2000 characters</mat-error>
                }
              </p>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Foundation</mat-label>
              <textarea matInput required id="stage1" formControlName="stage1" rows="4" maxlength="2000" (input)="capitalizeFirst($event, 'stage1')" aria-label="Foundation"></textarea>
            </mat-form-field>

            @if (form.get('stage1')?.invalid && (form.get('stage1')?.dirty || form.get('stage1')?.touched)) {
              <p>
                @if (form.get('stage1')?.hasError('maxlength')) {
                  <mat-error>Foundation cannot exceed 2000 characters</mat-error>
                }
              </p>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Demonstrating</mat-label>
              <textarea matInput required id="stage2" formControlName="stage2" rows="4" maxlength="2000" (input)="capitalizeFirst($event, 'stage2')" aria-label="Demonstrating"></textarea>
            </mat-form-field>

            @if (form.get('stage2')?.invalid && (form.get('stage2')?.dirty || form.get('stage2')?.touched)) {
              <p>
                @if (form.get('stage2')?.hasError('maxlength')) {
                  <mat-error>Demonstrating cannot exceed 2000 characters</mat-error>
                }
              </p>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Performing</mat-label>
              <textarea matInput required id="stage3" formControlName="stage3" rows="4" maxlength="2000" (input)="capitalizeFirst($event, 'stage3')" aria-label="Performing"></textarea>
            </mat-form-field>

            @if (form.get('stage3')?.invalid && (form.get('stage3')?.dirty || form.get('stage3')?.touched)) {
              <p>
                @if (form.get('stage3')?.hasError('maxlength')) {
                  <mat-error>Performing cannot exceed 2000 characters</mat-error>
                }
              </p>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Excelling</mat-label>
              <textarea matInput required id="stage4" formControlName="stage4" rows="4" maxlength="2000" (input)="capitalizeFirst($event, 'stage4')" aria-label="Excelling"></textarea>
            </mat-form-field>

            @if (form.get('stage4')?.invalid && (form.get('stage4')?.dirty || form.get('stage4')?.touched)) {
              <p>
                @if (form.get('stage4')?.hasError('maxlength')) {
                  <mat-error>Excelling cannot exceed 2000 characters</mat-error>
                }
              </p>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="panel-body">
          <button type="button" (click)="backButtonHandler($event)" mat-raised-button class="btn button-color-fix_red" [disabled]="isSubmitting">
            <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
            Back
          </button>
          <button mat-raised-button type="submit" class="btn button-color-fix pull-right" [disabled]="!canSubmit">
            @if (!isSubmitting) {
              <span>
                {{this.data?.isEditMode ? 'Update' : 'Create'}}
                <mat-icon class="icon-color-fix">save</mat-icon>
              </span>
            }
            @if (isSubmitting) {
              <span>
                Saving...
              </span>
            }
          </button>

        </div>
      </div>
    </form>
  </div>
</div>